export default __webpack_public_path__ + "static/media/crew-03-bit.1087b8f6.svg";